import {
  VpAudioMethods,
  VpBaseMethods,
  VpMovieClipMethods,
  VpDragonBoneMethods,
  VpParticleMethods,
  VpTweenMethods,
  VpVideoMethods,
  VpDrawLineMethods,
  VpEraseMethods,
} from '@ps/bridge/qc/vp/config'
import maskAction from './mask'
import carouselAction from './carousel'

const VpCategories = {
  animation: {
    single: '単一のアニメーション',
    all: 'すべてのアニメーション',
  },
  movieClip: 'シーケンスフレーム',
  dragonBone: 'ドラゴンボーン',
  particle: 'パーティクルエフェクト',
  basic: {
    switchAndAction: 'ジャンプとトラッキング',
    node: 'レイヤー',
    timer: 'タイマー',
    event: 'イベント',
    bgm: 'バックグラウンドミュージック',
  },
  audio: 'サウンド効果',
  video: 'ビデオ',
  drawLine: '連線コンポーネント',
  freeDrawLine: 'フリーハンド描画コンポーネント',
  erase: '消去コンポーネント',
  carousel: 'カルーセルコンポーネント',
  mask: 'マスクコンポーネント',
  other: 'その他',
}

export default {
  component: {
    switch: {
      'active-text': '有効にする',
      'inactive-text': '無効にする',
    },
  },
  action: {
    [VpTweenMethods.vpPlayTweenByUuid]: {
      label: '単一のアニメーションを再生する',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'アニメーションを選択します',
        },
      },
    },
    [VpTweenMethods.vpStopTweenByUuid]: {
      label: '単一のアニメーションの再生を一時停止します',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'アニメーションを選択します',
        },
      },
    },
    [VpTweenMethods.vpPlayTweenByUuidGoOn]: {
      label: '単一のアニメーションを再生します',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'アニメーションを選択します',
        },
      },
    },
    [VpTweenMethods.vpResetTweenPropByUuid]: {
      label: '単一アニメ初期化',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'アニメーションを選択します',
        },
      },
    },
    [VpTweenMethods.vpPlayTween]: {
      label: '全てのアニメーションを最初から再生します。',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenGoOn]: {
      label: '全てのアニメーションを再生します。',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpStopTween]: {
      label: '全てのアニメーションの再生を一時停止します。',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpResetTweenProp]: {
      label: '全アニメ初期化',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenChildrenAll]: {
      label: '全グループアニメーション再生',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpStopTweenChildrenAll]: {
      label: '全グループアニメーション一時停止',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenChildrenAllGoOn]: {
      label: 'グループアニメーション再開',
      category: VpCategories.animation.all,
    },
    [VpMovieClipMethods.vpPlayMC]: {
      label: 'シーケンスフレームを表示して再生します。',
      category: VpCategories.movieClip,
      paramFormConfig: {
        loop: {
          title: '無限ループで再生します。',
        },
        hideWhenFinished: {
          title: '再生完了後に非表示にするかどうか設定できます。',
        },
        pingpong: {
          title: '往復再生します。',
        },
        playTime: {
          title: '再生回数を設定できます。',
        },
      },
    },
    [VpMovieClipMethods.vpStopMC]: {
      label: 'シーケンスフレームの再生を一時停止します。',
      category: VpCategories.movieClip,
    },
    [VpDragonBoneMethods.vpPlaySKPlayer]: {
      label: '龍骨（DragonBones）を再生します。',
      category: VpCategories.dragonBone,
      paramFormConfig: {
        animationName: {
          title: 'アクションの名前を指定します。',
        },
        loop: {
          title: 'ループ再生するかどうか設定します。',
        },
        speed: {
          title: '再生速度を調整します。',
        },
      },
    },
    [VpDragonBoneMethods.vpStopSKPlayer]: {
      label: '龍骨（DragonBones）の再生を一時停止します。',
      category: VpCategories.dragonBone,
    },
    [VpParticleMethods.vpPlayParticle]: {
      label: '粒子特效の表示と再生',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpStopParticle]: {
      label: '粒子特效の一時停止',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpClearParticle]: {
      label: '粒子特效のクリア',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpParticleStartColor]: {
      label: '粒子の出生色',
      category: VpCategories.particle,
      paramFormConfig: {
        startColor: {
          title: '粒子の出生色',
        },
      },
    },
    [VpBaseMethods.vpSwitchScene]: {
      label: '指定されたシーンへの移動',
      category: VpCategories.basic.switchAndAction,
      paramFormConfig: {
        jumpSceneId: {
          title: '遷移先のシーン',
        },
      },
    },
    [VpBaseMethods.vpSwitchNextScene]: {
      label: '次のシーンへの移動',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpInstall]: {
      label: 'アプリストアへの移動',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpGameEnd]: {
      label: 'トライアル終了の報告',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpSendAction]: {
      label: 'トラッキングイベントの設定',
      category: VpCategories.basic.switchAndAction,
      paramFormConfig: {
        action_id: {
          title: 'トラッキングID',
        },
        action_name: {
          title: 'トラッキング名',
        },
      },
    },
    [VpBaseMethods.vpPosition]: {
      label: '位置の設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        position: {
          title: 'いち',
        },
      },
    },
    [VpBaseMethods.vpScaleXY]: {
      label: 'スケールの設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        scale: {
          title: 'しゅくしゃくひ',
        },
      },
    },
    [VpBaseMethods.vpRotate]: {
      label: '回転の設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        rotation: {
          title: '回転角度',
        },
      },
    },
    [VpBaseMethods.vpWidth]: {
      label: '幅の設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        width: {
          title: '幅の設定',
        },
      },
    },
    [VpBaseMethods.vpHeight]: {
      label: '高さの設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        height: {
          title: '高さの設定',
        },
      },
    },
    [VpBaseMethods.vpShowHide]: {
      label: 'レイヤーの表示/非表示',
      category: VpCategories.basic.node,
      paramFormConfig: {
        isShow: {
          title: '表示/非表示',
          field: {
            options: [
              {
                label: '表示する',
              },
              {
                label: '非表示にする',
              },
            ],
          },
        },
      },
    },
    [VpBaseMethods.vpAlpha]: {
      label: '透明度の設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        alpha: {
          title: '透明度の設定',
        },
      },
    },
    [VpBaseMethods.vpColor]: {
      label: '色の設定',
      category: VpCategories.basic.node,
      paramFormConfig: {
        color: {
          title: '色の設定',
        },
      },
    },
    [VpBaseMethods.vpWaitTime]: {
      label: '遅延実行',
      category: VpCategories.basic.timer,
      paramFormConfig: {
        ms: {
          title: '遅延時間',
        },
        timerId: {
          title: 'タイマー名',
        },
        lastTimerId: {},
      },
    },
    [VpBaseMethods.vpClearTime]: {
      label: '遅延実行のキャンセル',
      category: VpCategories.basic.timer,
      paramFormConfig: {
        timerId: {
          title: 'タイマーID',
        },
      },
    },
    [VpBaseMethods.enabledEvent]: {
      label: 'イベントの無効化/有効化',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: 'イベント',
        },
        enabled: {
          title: '無効化/有効化',
        },
      },
    },
    [VpBaseMethods.enabledEventActive]: {
      label: 'イベントを有効化する',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: 'イベント',
        },
      },
    },
    [VpBaseMethods.enabledEventBan]: {
      label: 'イベントを無効化する',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: 'イベント',
        },
      },
    },
    [VpBaseMethods.vpPlayBgm]: {
      label: '背景音楽の再生',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpReplayBgm]: {
      label: '最初から背景音楽を再生',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpResumeBgm]: {
      label: '背景音楽の再開',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpStopBgm]: {
      label: '背景音楽の一時停止',
      category: VpCategories.basic.bgm,
    },
    [VpAudioMethods.vpPlaySound]: {
      label: '効果音の再生',
      category: VpCategories.audio,
      paramFormConfig: {
        isStop: {
          title: '最初から再生するかどうか',
        },
        loop: {
          title: '無限ループ',
        },
        loopNumber: {
          title: '再生回数',
        },
      },
    },
    [VpAudioMethods.vpReplaySound]: {
      label: '最初から効果音を再生',
      category: VpCategories.audio,
      paramFormConfig: {
        loop: {
          title: '無限ループ',
        },
        loopNumber: {
          title: '再生回数',
        },
        isStopSound: {
          title: '再びトリガーされたときに、前回トリガーされた音声を停止します',
        },
      },
    },
    [VpAudioMethods.vpResumeSound]: {
      label: '音声再生を継続する',
      category: VpCategories.audio,
    },
    [VpAudioMethods.vpStopSound]: {
      label: '音声再生を一時停止する',
      category: VpCategories.audio,
      paramFormConfig: {
        isStop: {
          title: '現在のシーンの全ての音声を一時停止するかどうか',
        },
      },
    },
    [VpVideoMethods.vpPlayVideo]: {
      label: 'ビデオ再生',
      category: VpCategories.video,
      paramFormConfig: {
        loopNumber: {
          title: '再生回数',
        },
        loop: {
          title: '無限ループ',
        },
        playEndFrame: {
          title: '最後のフレームを保持する',
        },
      },
    },
    [VpVideoMethods.vpReplayVideo]: {
      label: 'ビデオを最初から再生する',
      category: VpCategories.video,
      paramFormConfig: {
        loopNumber: {
          title: '再生回数',
        },
        loop: {
          title: '無限ループ',
        },
        playEndFrame: {
          title: '最後のフレームを保持する',
        },
      },
    },
    [VpVideoMethods.vpResumeVideo]: {
      label: 'ビデオ再生を継続する',
      category: VpCategories.video,
    },
    [VpVideoMethods.vpStopVideo]: {
      label: 'ビデオ再生を一時停止する',
      category: VpCategories.video,
    },
    [VpVideoMethods.vpPauseVideo]: {
      label: 'ビデオ再生を一時停止する',
      category: VpCategories.video,
    },
    [VpDrawLineMethods.vpEraseLine]: {
      label: '接続線を消去する',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: 'オブジェクトを削除する',
        },
      },
    },
    [VpDrawLineMethods.vpModifyLineStyle]: {
      label: '接続線のスタイルを変更する',
      category: VpCategories.drawLine,
      paramFormConfig: {
        area: {
          title: '開始終了領域',
        },
        lineColor: {
          title: '線の色',
        },
        lineStyle: {
          title: '線の太さ',
        },
      },
    },
    [VpDrawLineMethods.vpEnablePair]: {
      label: 'ペアリングを有効化/無効化する',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: 'ペアリング',
        },
        enableBan: {
          title: '有効化/無効化',
          field: {
            options: [
              {
                label: '有効化',
              },
              {
                label: '無効化',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpModifyPairLineStyle]: {
      label: '既に接続されたペアの線のスタイルを変更する',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: 'ペアリング',
        },
        lineColor: {
          title: '線の色',
        },
        lineStyle: {
          title: '線の太さ',
        },
      },
    },
    [VpDrawLineMethods.vpEnableBanArea]: {
      label: '開始終了領域の有効化/無効化',
      category: VpCategories.drawLine,
      paramFormConfig: {
        area: {
          title: '開始終了領域',
        },
        enableBan: {
          title: '有効化/無効化',
          field: {
            options: [
              {
                label: '有効化',
              },
              {
                label: '無効化',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpFreeEraseLine]: {
      label: 'フリーハンドで描いた線を消去する',
      category: VpCategories.freeDrawLine,
    },
    [VpDrawLineMethods.vpFreeModifyLineStyle]: {
      label: 'フリーハンドで描いた線のスタイルを変更する',
      category: VpCategories.freeDrawLine,
      paramFormConfig: {
        lineColor: {
          title: '線の色',
        },
        lineStyle: {
          title: '線の太さ',
        },
      },
    },
    [VpDrawLineMethods.vpFreeEnable]: {
      label: 'フリーハンド描画コンポーネントの有効化/無効化',
      category: VpCategories.freeDrawLine,
      paramFormConfig: {
        enableBan: {
          title: '有効化/無効化',
          field: {
            options: [
              {
                label: '有効化',
              },
              {
                label: '無効化',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpFreeEnableRigidBody]: {
      label: '既に描かれた線から剛体を生成する',
      category: VpCategories.freeDrawLine,
    },
    [VpEraseMethods.vpEnableEraseComponent]: {
      label: '消去コンポーネントの有効化または無効化',
      category: VpCategories.erase,
      paramFormConfig: {
        isEnable: {
          title: '有効化/無効化',
          field: {
            options: [
              {
                label: '有効化',
              },
              {
                label: '無効化',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpEraseTrace]: {
      label: '擦り跡を消去',
      category: VpCategories.erase,
      paramFormConfig: {},
    },
    [VpEraseMethods.vpShowGroup]: {
      label: 'グループを表示/非表示',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
        isShow: {
          title: '表示/非表示',
          field: {
            options: [
              {
                label: '表示',
              },
              {
                label: '非表示',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpEnableEraseableGroup]: {
      label: '消去可能なグループの有効化/無効化',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
        isEnable: {
          title: '有効化/無効化',
          field: {
            options: [
              {
                label: '有効化',
              },
              {
                label: '無効化',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpPlayAllMovieClipForGroup]: {
      label: 'グループのすべてのフレームを表示して再生',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
      },
    },
    [VpEraseMethods.vpPauseAllMovieClipForGroup]: {
      label: 'グループのすべてのフレームを一時停止',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
      },
    },
    [VpEraseMethods.vpPlayTweenForGroup]: {
      label: 'グループの単一のアニメーションを再生',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
        vpTweenUuid: {
          title: 'アニメーションを選択',
        },
      },
    },
    [VpEraseMethods.vpPauseTweenForGroup]: {
      label: 'グループの単一のアニメーションを一時停止',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
        vpTweenUuid: {
          title: 'アニメーションを選択',
        },
      },
    },
    [VpEraseMethods.vpPlayTweenGoOnForGroup]: {
      label: 'グループの単一のアニメーションを再開',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
        vpTweenUuid: {
          title: 'アニメーションを選択',
        },
      },
    },
    [VpEraseMethods.vpPlayAllTweenForGroup]: {
      label: 'グループのすべてのアニメーションを再生',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
      },
    },
    [VpEraseMethods.vpPauseAllTweenForGroup]: {
      label: 'グループのすべてのアニメーションを一時停止',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
      },
    },
    [VpEraseMethods.vpPlayAllTweenGoOnForGroup]: {
      label: 'グループのすべてのアニメーションを再開',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
        },
      },
    },
    [VpEraseMethods.vpReplaceHandImage]: {
      label: '追従画像を置換',
      category: VpCategories.erase,
      paramFormConfig: {
        handImage: {
          title: '追従画像',
        },
      },
    },
    [VpBaseMethods.vpShakeScreen]: {
      label: '画面の揺れ効果',
      category: VpCategories.other,
      paramFormConfig: {
        duration: {
          title: '持続時間',
        },
        fequence: {
          title: '振動の頻度',
        },
        xy: {
          title: '振動の最大距離',
        },
      },
    },
    [VpBaseMethods.vpCompute]: {
      label: '代入',
      category: VpCategories.other,
      paramFormConfig: {
        target: {
          title: 'グローバル変数',
        },
        method: {
          title: '演算方法',
        },
        value: {
          title: '演算数',
        },
      },
    },
    [VpBaseMethods.vpRetry]: {
      label: '再試行',
      category: VpCategories.other,
    },
    ...maskAction.maskAction,
    ...carouselAction.carouselAction,
  },
  VpCategories,
}
